import React, { Fragment, ComponentProps, FC } from "react";
import TableDataDesktop from "./TableDataDesktop";
import TableDataMobile from "./TableDataMobile";
import { TableDataMobileProps } from "./TableDataMobile/TableDataMobile";
import { DesktopOnly, NoDesktop } from "../../atoms/ViewportRestrictor";

type TableDataDesktopProps = ComponentProps<typeof TableDataDesktop>;
type TableDataProps = TableDataDesktopProps & TableDataMobileProps;

const TableData: FC<TableDataProps> = (props) => (
  <Fragment>
    <DesktopOnly>
      <TableDataDesktop {...props} />
    </DesktopOnly>

    <NoDesktop>
      <TableDataMobile {...props} />
    </NoDesktop>
  </Fragment>
);

export default TableData;
